import { QR_CODE_TYPES } from "constants/qrCodeTypes";

function qrCodeTypesToLabel(qrCodeType) {
  return QR_CODE_TYPES[qrCodeType];
}

export { qrCodeTypesToLabel };
